export default __webpack_public_path__ + "static/media/road-works.0549c2ea.svg";